//波兰语
export default {
    login1: 'Masz już konto? ',
    login2: 'Przejdź do logowania',
    login3: 'Zresetować hasło? ',
    login4: "Rozpocznij korzystanie z 51shopy",
    login5: 'Zapomniałeś hasła?',
    login6: 'Zarejestruj się teraz',
    login7: 'E-mail',
    login8: 'Kod weryfikacyjny',
    login9: 'Wprowadź kod weryfikacyjny',
    login10: 'hasło',
    login11: 'Potwierdź hasło',
    login12: 'Wprowadź ponownie swoje hasło',
    login13: 'Zarejestruj',
    login14: "Następny krok",
    login15: 'Prześlij',
    login16: 'Wyślij kod weryfikacyjny',
    login17: 'Wprowadź prawidłowy adres e-mail i kod weryfikacyjny! ',
    login18: 'Podane dwukrotnie hasła nie są takie same!',
    login19: 'Kod weryfikacyjny został wysłany',
    login20: 'Adres e-mail nie może być pusty',
    login21: "Format adresu e-mail jest nieprawidłowy",
    login22: 'Kod weryfikacyjny nie może być pusty',
    login23: 'Długość kodu weryfikacyjnego wynosi 4 znaki',
    login24: 'Hasło nie może być puste',
    login25: 'Długość hasła nie może być krótsza niż 6 znaków',
    login26: 'Hasło zostało pomyślnie zmienione! ',
    login27: 'Rejestracja zakończona sukcesem! ',
    login28: 'Logowanie powiodło się',
    login29: 'Nazwa konta nie może być pusta',
    login30: "Zaloguj się na swoje konto poniżej, aby rozpocząć",
    login31: 'Konto',
    login32: 'Kliknij, aby się zalogować',
    login33: "Kupuj produkty wysokiej jakości i korzystaj z bonusów",
    login34: "Zarejestruj się, aby otrzymać wspaniały prezent",
    login35: "Zaloguj się",
    login36: "Zarejestruj",
    home1: 'Popularne',
    home2: "Czy na pewno chcesz się wylogować? ",
    home3: 'Monit',
    home4: 'OK',
    home5: 'Anuluj',
    home6: 'Fani',
    home7: 'Śledź',
    home8: 'Centrum osobiste',
    home9: "Kupiłem to",
    home10: "Sprzedałem to",
    home11: "Mój portfel",
    home12: 'Wyjście',
    home13: 'Całkowity',
    home14: 'elementy',
    home15: "Osada",
    home16: 'Przystępna cena',
    home17: 'Szybka logistyka',
    home18: 'Zapewnienie jakości',
    home19: 'O nas',
    home20: 'Centrum pomocy',
    home21: 'Obsługa posprzedażna',
    home22: 'Dostawa i akceptacja',
    home23: 'Współpraca biznesowa',
    home24: 'Rekomendacje wyszukiwania',
    home25: 'Przyjazne linki',
    home26: 'Śledź',
    home27: 'Już zaniepokojony',
    home28: 'Kup teraz',
    home29: 'Dodaj do koszyka',
    home30: 'Zbieranie zakończone sukcesem! ',
    home31: 'Anuluj kolekcję pomyślnie! ',
    home32: 'Czy na pewno chcesz przestać obserwować?',
    home33: 'Anulowano pomyślnie! ',
    home34: 'Śledź sukces! ',
    home35: 'Zawartość nie może być pusta',
    home36: 'Komentarz pomyślny!',
    home37: 'Recenzje produktów',
    home38: 'Oceń teraz',
    home39: 'Ocena',
    home40: 'Historia',
    home41: 'Przestań obserwować pomyślnie! ',
    home42: 'Ten facet jest bardzo tajemniczy i nie ma żadnej biografii. ',
    home43: 'Str. gł.',
    number1: 'Moje konto',
    number2: "Centrum osobiste",
    number3: 'Portfel',
    number4: "Moje ulubione",
    number5: "Moja uwaga",
    number6: "Moi fani",
    number7: 'Przeglądanie historii',
    number8: "Zarządzanie transakcjami",
    number9: "Wysłałem",
    number10: "kupiłem",
    number11: "Sprzedałem to",
    number12: "Koszyk",
    number13: 'Strona główna osobista',
    number14: "Obsługa klienta",
    number15: "Ustawienia",
    number16: 'Dodaj nowy adres',
    number17: 'Modyfikuj adres',
    number18: 'Można przesyłać tylko pliki graficzne!',
    number19: 'Rozmiar pliku nie może przekraczać 10 MB!',
    number20: 'Obraz przesłano pomyślnie',
    number21: 'Równowaga',
    number22: 'Zbieraj przedmioty',
    number23: 'Dane osobowe',
    number24: 'Edytuj',
    number25: 'Prześlij',
    number26: 'Pseudonim',
    number27: "Profil osobisty",
    number28: 'adres dostawy',
    number29: 'Dodaj',
    number30: 'Domyślne',
    number31: 'Nie zapłacono',
    number32: "Czekam na dostawę",
    number33: 'Zakończono',
    number34: 'Anulowano',
    number35: "Oczekuje na sprawdzenie",
    number36: 'Zaliczone',
    number37: "Odrzucono",
    number38: 'Zamówienie zrealizowane',
    number39: 'Płatność za zamówienie została zrealizowana pomyślnie!',
    number40: 'Zamówienie anulowane pomyślnie! ',
    number41: 'Wypłata zakończona sukcesem! ',
    number42: "Doładuj",
    number43: "Wycofaj",
    number44: 'Historia zużycia',
    number45: 'Nr. zamówienia',
    number46: 'nazwa płatności',
    number47: 'Wszystko',
    number48: 'Zapytanie',
    number49: 'Nr. zamówienia',
    number50: 'nazwa płatności',
    number51: 'moneta 51',
    number52: 'Status zamówienia',
    number53: 'Czas utworzenia zamówienia',
    number54: 'Czas aktualizacji zamówienia',
    number55: 'Operacja',
    number56: 'Zapłacono',
    number57: 'Anuluj zamówienie',
    number58: 'Szczegóły',
    number59: 'Numer',
    number60: 'wysłano',
    number61: 'oczekujący',
    number62: 'Rejestr wypłat',
    number63: 'identyfikator użytkownika',
    number64: 'Kwota wypłaty',
    number65: 'Status',
    number66: 'Czas utworzenia',
    number67: 'Wypłać z portfela',
    number68: 'Wycofaj',
    number69: 'Szczegóły zamówienia portfela',
    number70: 'Wszystkie zamówienia',
    number71: 'Oczekująca płatność',
    number72: "Czekam na dostawę",
    number73: 'Zakończono',
    number74: 'Anulowano',
    number75: 'Zapłacono',
    number76: 'Wszystkie przesyłki',
    number77: 'Nr. zamówienia logistycznego',
    number78: 'Wysyłka zakończona sukcesem!',
    number79: "Sprzedałem to",
    number80: "Brak danych o zamówieniu",
    number81: 'Nr. zamówienia',
    number82: 'Czas zamówienia',
    number83: 'Osoba zamawiająca',
    number84: 'Czas zmiany',
    number85: 'szczegóły',
    number86: 'Całkowity',
    number87: 'wysłano',
    number88: 'Szczegóły',
    number89: "Wpisz Nr. zamówienia logistycznego",
    number90: 'Nr. zamówienia logistycznego',
    number91: 'Proszę wprowadzić Nr. zamówienia logistycznego',
    number92: 'Anuluj pomyślnie!',
    number93: 'Sukces!',
    number94: 'Zamówienie opóźnione, dostawa zakończona sukcesem!',
    number95: "Kupiłem",
    number96: 'Zapłać teraz',
    number97: 'Potwierdź odbiór',
    number98: 'Opóźniona dostawa',
    number99: 'Anuluj zamówienie',
    number100: 'Użytkownik Sprzedawcy',
    number101: "Moja kolekcja",
    number102: "Moi fani",
    number103: "Moje obserwowane",
    number104: 'nazwa płatności',
    number105: '51 monet',
    number106: 'Status zamówienia',
    number107: 'Czas płatności',
    number108: "Zapłaciłem",
    number109: 'Zamówienie zostało zapłacone pomyślnie! ',
    number110: 'Wszystkie produkty',
    number111: 'Czy na pewno chcesz usunąć produkt?',
    number112: 'Usunięto pomyślnie! ',
    number113: 'Anulowano pomyślnie! ',
    number114: 'Czy na pewno chcesz odłożyć produkt na półkę?',
    number115: 'Czy na pewno chcesz usunąć produkt?',
    number116: 'Sukces! ',
    number117: "Na półce",
    number118: "gotowy",
    number119: 'Usuń',
    number120: 'Zobacz szczegóły',
    cart1: 'Informacje o produkcie',
    cart2: 'cena jednostkowa',
    cart3: 'Ilość',
    cart4: 'Suma częściowa',
    cart5: 'operacja',
    cart6: 'cena jednostkowa',
    cart7: 'Czy na pewno chcesz usunąć?',
    cart8: 'Potwierdź',
    cart9: 'Anuluj',
    cart10: 'usuń',
    cart11: "Lista koszyka jest pusta",
    cart12: 'pozycji, suma produktów',
    cart13: 'Razem',
    cart14: 'Osiedle',
    cart15: 'Dodaj adres',
    cart16: "Należy wypełnić jedno z pól telegram i watchApp",
    cart17: 'Konfiguracja informacji o użytkowniku zakończona sukcesem!',
    cart18: 'Proszę wybrać lub wypełnić adres dostawy! ',
    cart19: 'Zamówienie zostało utworzone pomyślnie! ',
    cart20: 'adres dostawy',
    cart21: "Przed złożeniem zamówienia musisz dodać adres dostawy. ",
    cart22: 'Odbiorca',
    cart23: 'Dane kontaktowe',
    cart24: 'adres dostawy',
    cart25: 'Przełącz adres',
    cart26: 'Dodaj adres',
    cart27: 'Informacje o produkcie',
    cart28: 'Cena jednostkowa',
    cart29: 'Ilość',
    cart30: 'Rzeczywista płatność',
    cart31: 'Całkowita cena',
    cart32: 'Szczegóły kwoty',
    cart33: 'Całkowita kwota do zapłaty',
    cart34: 'Złóż zamówienie',
    cart35: "Zmień adres dostawy",
    cart36: 'Anuluj',
    cart37: 'OK',
    cart38: 'Informacje o użytkowniku',
    cart39: 'Prześlij',
    cart40: 'Nazwisko nie może być puste',
    cart41: 'Nazwa nie może być pusta',
    cart42: 'Numer telefonu komórkowego nie może być pusty',
    cart43: 'Kraj nie może być pusty',
    cart44: 'Województwo/Gmina/Powiat nie może być pusty',
    cart45: 'Miasto nie może być puste',
    cart46: 'Szczegółowy adres nie może być pusty',
    cart47: 'Kod pocztowy nie może być pusty',
    cart48: 'Adres został pomyślnie zmodyfikowany! ',
    cart49: 'Adres został pomyślnie dodany! ',
    cart50: 'nazwisko',
    cart51: 'nazwa',
    cart52: 'Kraj',
    cart53: 'Prowincja/Gmina/Region',
    cart54: 'miasto',
    cart55: 'Szczegółowy adres',
    cart56: 'Kod pocztowy',
    cart57: 'Numer telefonu kontaktowego',
    cart58: "Czy to jest domyślne?",
    cart59: 'Str. gł.',
    cart60: 'Obsługa klienta',
    cart61: 'Publikuj',
    cart62: 'Mój',
    cart63: 'koszyk',
    cart64: 'Czas wysyłki',
    cart65: 'Czas płatności',
    cart66: 'dane odbiorcy',
    cart67: 'Rzeczywista płatność',
    cart68: 'Wyślij do',
    cart69: 'Produkty',
    cart70: "Możesz ubiegać się o fakturę",
    cart71: 'Informacje o zamówieniu',
    cart72: 'Kupiec',
    cart73: 'Wysłano pomyślnie! ',
    cart74: 'Kopiowanie powiodło się',
    cart75: 'Kopiowanie nie powiodło się',
    cart76: 'proporcja',
    cart77: 'Limit kredytowy',
    cart78: 'Przenieś',
    cart79: 'Kwota doładowania',
    cart80: 'Doładuj',
    cart81: 'Klasyfikacja',
    setup1: 'Dane osobowe',
    setup2: "Mój adres dostawy",
    setup3: "Mój profil",
    setup4: 'Konto i bezpieczeństwo',
    setup5: 'Prywatność',
    setup6: 'Ogólne',
    setup7: 'Pomoc i opinie',
    setup8: 'O nas',
    setup9: "Wyloguj się",
    setup10: 'Wiadomość stacji',
    setup11: "Brak danych",
    setup12: 'Dodanie do koszyka powiodło się!',
    setup13: 'Dodanie do koszyka nie powiodło się!',

    setup14: 'Edycja produktu',
    setup15: "Wydanie produktu",
    setup16: 'Obraz na okładce produktu',
    setup17: 'Kategoria produktu',
    setup18: 'Nazwa produktu',
    setup19: 'Cena produktu (CNY)',
    setup20: 'Opis produktu',
    setup21: 'Zdjęcia produktów (Maks. 10 zdjęć)',
    setup22: 'Resetuj',
    setup23: 'Produkt został pomyślnie utworzony! ',
    setup24: 'Niewystarczający zapas produktu! ',
    setup25: 'Metoda płatności',
    setup26: '51coin',
    setup27: 'przeniesienie',
    setup28: 'Link do produktu lub link do nazwy/pozycji',
    setup29: 'Użytkownik nie jest sprzedawcą i nie może publikować produktów! ',
    setup30: 'Wykryto operację niewykonaną przez człowieka! ',
    setup31: 'Inwentarz produktów',
    setup32: 'Widoki',
    setup33: 'Zamówienie zostało pomyślnie wysłane! ',
    setup34: 'Wyświetl zamówienie',
    setup35: 'Inwentarz produktów',
    setup36: 'Kategoria produktu nie może być pusta',
    setup37: 'Nazwa produktu nie może być pusta',
    setup38: 'Opis produktu nie może być pusty',
    setup39: 'Zapasy produktów nie mogą być puste',
    setup40: 'Pole cena produktu nie może być puste',
    setup41: 'Obraz na okładce nie może być pusty',
    setup42: 'Obraz produktu nie może być pusty',
    setup43: "Transfer został wykonany i oczekuje na potwierdzenie",
    setup44: 'Wybierz metodę transferu! ',
    setup45: 'Czas ukończenia',
    setup46: 'Moneta 51',
    setup47: 'Płatn. przelew',
    setup48: 'Metoda transferu',
    setup49: "Szczegóły produktu",
    setup50: "Kupujący",
    setup51: "Koszt wysyłki produktu wynosi",
    setup52: "Opłata za wysyłkę",
    setup53: "Ilość sprzedaży",
    setup54: "Minimalna ilość zakupu",
    setup55: "Dodaj nowy adres",
    setup56: "Konto zostało otrzymane",
    setup57: "Dane kontaktowe odbiorcy",
    setup58: "Dane kontaktowe sprzedawcy",
    setup59: "Dane kontaktowe kupującego",
    setup60: "Kopiuj",
    setup61: "Popularne",
    setup62: "Wypełnij przynajmniej jedno pole",
    setup63: "Skontaktuj się z nami",
    setup64: "Estym. kosztów",
    setup65: "Subskrybuj nas",
    setup66: "Współpraca zagranicznych gwiazd Internetu",
    setup67: "Problemy z płatnością i obsługą posprzedażową",
    setup68: "Dywidendy użytkownika",
    setup69: "Typ waluty",
    setup70: "Kurs wymiany",
    setup71: "Opłata manipulacyjna",
    setup72: "Rzeczywisty paragon",
    setup73: "Minimalna kwota wypłaty",
    setup74: "Waluta",
    setup75: "Opłata manipulacyjna",
    setup76: "Rzeczywisty paragon",
    setup78: "Kod zaproszenia",
    setup79: "Wprowadź kod zaproszenia",
    setup80: "Pole numeru kierunkowego telefonu komórkowego nie może być puste",
    setup81: "Kod kierunkowy",
    setup82: "Anuluj czas",
    setup83: "Szczegóły wypłaty",
    setup84: "Szczegóły dywidendy",
    setup85: "Czy wygasło?",
    setup86: "Czy używać",
    setup87: "Nie wygasło",
    setup88: "Wygasło",
    setup89: "Nieużywane",
    setup90: "Już użyto",
    setup91: "Częściowo używany",
    setup92: "rabat",
    setup93: "Użyty rabat",
    setup94: "Pozostały rabat",
    setup95: "Czy używać",
    setup96: "Czy wygasło?",
    setup97: "Czas wygaśnięcia",
    setup98: "Czas rabatu",
    setup99: "Udostępnianie sojuszu",
    setup100: "Anuluj płatność",
    setup101: "Zamknij interfejs",
    setup102: "Płatność USDT",
    setup103: "Kwota zapłacona",
    setup104: "Kwota transakcji zamówienia",
    setup105: "Sieć",
    setup106: "Płacisz za sieć",
    setup107: "Płatność powiodła się",
    setup108: "Adres portfela odbiorcy",
    setup109: "Proszę dokładnie sprawdzić, czy faktyczna kwota płatności jest zgodna z kwotą, którą przelałeś. Jeśli wystąpi jakiś błąd, sam poniesiesz konsekwencje",
    setup110: "Czas wygaśnięcia",
    setup111: "Czekam na zapłatę",
    setup112: "Płatność powiodła się",
    setup113: "Zamówienie wygasło",
    setup114: "Sprawdź transakcje blockchain",
    setup130: "O nas",
    setup131: "Dotyczące dostawy",
    setup132: "Inne",
    setup133: "Zasady wysyłki",
    setup134: "Czas dostarczenia/odbioru przesyłki",
    setup135: "Warunki korzystania z usługi",
    setup136: "Metoda płatności",
    setup137: "Polityka zwrotów",
    setup138: "Polityka prywatności",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Godziny pracy:",
    setup141: "Osoba kontaktowa:",
    setup142: "Adres e-mail firmy:",
    setup143: "Kod pocztowy:",
    setup144: "Adres: ",
    setup0140: "Od poniedziałku do piątku (9:00-18:00)",
    setup0141: "Pan Liang",
    setup0143: "999077",
    setup0144: "Pokój 341, 3. piętro, Publiczny budynek przemysłowy, 56 Hoi Yuen Road, Kwun Tong, Hongkong",
    setup145: "Międzynarodowa umowa o wysyłce paczek",
    setup146: "Ze względu na specyfikę transportu międzynarodowego, musisz przestrzegać międzynarodowych zasad transportu paczek. Przeczytaj uważnie i zaakceptuj poniższe warunki.",
    setup147: "Standard rekompensaty za pakiet:",
    setup148: "Jeśli Twoje produkty zostaną zgubione, zaginą, uszkodzone, opóźnione lub zatrzymane przez służby celne podczas transportu z przyczyn niezależnych od 51shopy, 51shopy nie będzie ponosić odpowiedzialności za odszkodowanie. Nie ponosimy również żadnej odpowiedzialności za pośrednie, niezrealizowane straty zysku. Aby uzyskać rzeczywiste szczegóły, zapoznaj się z „Ubezpieczeniem przesyłki i odszkodowaniem”.",
    setup149: "51shopy nie ponosi odpowiedzialności za odszkodowania w następujących przypadkach (dla przesyłek nieubezpieczonych):",
    setup150: "1. Nie przysługuje żadne odszkodowanie za utratę przesyłki spowodowaną siłą wyższą, taką jak klęski żywiołowe lub przyczyny celne;",
    setup151: "2. Jeżeli wysłane przesyłki naruszają zakazy lub ograniczenia, właściwe organy skonfiskują je lub potraktują zgodnie z odpowiednimi przepisami prawa i regulacjami bez odszkodowania;",
    setup152: "3. W przypadku wysyłki przesyłki, jeśli jest ona zapakowana w dobrym stanie, nie nosi śladów demontażu i nie straciła na wadze, ale brakuje jej wewnętrznych części lub są one uszkodzone, odszkodowanie nie zostanie udzielone;",
    setup153: "4. Jeżeli z rejestru pocztowego wynika, że ​​paczka nie została dostarczona w sposób normalny, a firma logistyczna potwierdzi, że paczka została skonfiskowana przez urząd celny, rozstrzygające jest dochodzenie firmy logistycznej i nie zostanie wypłacone żadne odszkodowanie;",
    setup154: "5. Nie przysługuje żadne odszkodowanie, jeśli przesyłka zostanie zgubiona lub jej zawartość zaginie z winy klienta lub samej przesyłki;",
    setup155: "6. Jeżeli klient nie złoży zapytania i nie złoży reklamacji od daty doręczenia wiadomości e-mail do upływu okresu zapytania, odszkodowanie nie zostanie przyznane;",
    setup156: "7. Jeśli poczta międzynarodowa zostanie zatrzymana, skonfiskowana lub zniszczona przez kraj docelowy zgodnie z jego prawem krajowym, nie zostanie przyznane żadne odszkodowanie.",
    setup157: "Przedmioty zabronione",
    setup158: "Przestrzegaj przepisów naszego kraju dotyczących przedmiotów zabronionych i objętych ograniczeniami:",
    setup159: "1. Stosować się do komunikatu Państwowego Urzędu Pocztowego, Ministerstwa Bezpieczeństwa Publicznego i Ministerstwa Bezpieczeństwa Państwowego w sprawie wydania „Przepisów dotyczących zarządzania przedmiotami zakazanymi”.",
    setup160: "2. Przestrzegać postanowień Rozporządzenia Ogólnego Administracji Celnej nr 43 (Lista artykułów zakazanych i objętych ograniczeniami w imporcie i eksporcie Chińskiej Republiki Ludowej).",
    setup161: "Przedmioty, których nie można wysłać pocztą",
    setup162: "1. Przedmioty, których obrót i transport są zabronione zgodnie z prawem krajowym.",
    setup163: "2. Materiały wybuchowe, łatwopalne, żrące, radioaktywne lub toksyczne niebezpieczne.",
    setup164: "3. Publikacje, książki, materiały lub artykuły zawierające treści reakcyjne lub obsceniczne.",
    setup165: "4. Różne waluty.",
    setup166: "5. Elementy naruszające zdrowie publiczne.",
    setup167: "6. Produkty nietrwałe.",
    setup168: "7. Zwierzęta żywe (z wyjątkiem pszczół, jedwabników i pijawek, pod warunkiem, że opakowanie zapewnia bezpieczeństwo pracowników).",
    setup169: "8. Nieodpowiednie opakowanie może stanowić zagrożenie dla pracowników lub zanieczyścić lub uszkodzić inne zapakowane przedmioty.",
    setup170: "9. Inne przedmioty nie nadające się do wysyłki.",
    setup171: "Przedmioty, których dostawa jest zabroniona zgodnie z praktyką pocztową",
    setup172: "1. Przedmioty, których jakość lub opakowanie może spowodować szkody dla pracowników pocztowych lub zanieczyścić/uszkodzić inne przesyłki lub sprzęt pocztowy.",
    setup173: "2. Przedmioty z metalowymi plombami lub innymi ostrymi krawędziami, które mogą utrudniać przetwarzanie pocztowe.",
    setup174: "3. Różne rodzaje broni palnej, amunicji, materiałów wybuchowych, łatwopalnych, żrących, radioaktywnych lub pojemników, silnych trucizn, narkotyków, produktów biochemicznych i materiałów zakaźnych.",
    setup175: "4. Wszelkie publikacje, materiały propagandowe lub materiały drukowane, które mogą zagrozić bezpieczeństwu społecznemu i stabilności lub zawierać treści obsceniczne.",
    setup176: "5. Różne przedmioty, które mogą zagrażać zdrowiu publicznemu.",
    setup177: "6. Dokumenty lub artykuły, które nie są akceptowane lub nie mogą być przedmiotem obiegu w kraju przyjmującym.",
    setup178: "Dostępne metody płatności",
    setup179: "Strona obsługuje wiele metod płatności, w tym karty kredytowe/debetowe, WeChat, Alipay itp. Jeśli musisz dokonywać częstych płatności lub potrąceń depozytowych, możesz również użyć salda do zapłaty.",
    setup180: "- Jeśli zwrot dotyczy zamówienia opłaconego kartą kredytową/debetową, zostanie on zwrócony na oryginalne konto; zwrot za doładowanie salda również zostanie zwrócony na oryginalne konto",
    setup181: "- W przypadku zwrotu pieniędzy za zamówienie opłacone za pośrednictwem WeChat, Alipay itp., zwrot zostanie przelany na oryginalne konto;",
    setup182: "- Jeżeli nastąpi zwrot salda płatności, zostanie ono zwrócone na saldo konta;",
    setup183: "Polityka prywatności użytkownika 51shopy",
    setup184: "Bezpieczeństwo Twoich danych osobowych jest dla nas bardzo ważne i cenimy Twoje zaufanie. W żadnym wypadku nie sprzedamy ani nie ujawnimy Twoich danych osobowych osobom trzecim. Będziemy chronić bezpieczeństwo i prywatność wszelkich danych osobowych, które nam przekazujesz, i wykorzystamy je wyłącznie w sposób opisany w niniejszym dokumencie. Jeśli masz jakiekolwiek pytania, sugestie lub komentarze dotyczące niniejszej Polityki prywatności, możesz skontaktować się z nami w dowolnym momencie, odwiedzając system obsługi klienta online 51shopy lub oficjalne konto serwisowe 51shopy.",
    setup185: "Niniejsza polityka nie ma zastosowania do usług świadczonych Tobie przez inne podmioty trzecie, ani do usług, dla których niezależnie ustaliliśmy zasady ochrony prywatności.",
    setup186: "Przed skorzystaniem z usług 51shopy przeczytaj uważnie i zrozum tę politykę. Twoja zgoda na tę politykę prywatności oznacza, że ​​zrozumiałeś funkcje udostępniane przez tę aplikację i niezbędne dane osobowe wymagane do uruchomienia tych funkcji.",
    setup187: "Prawa własności i eksploatacji odpowiednich zarejestrowanych usług użytkownika należą do ",
    setup188: "1. Jakie dane osobowe zbieramy?",
    setup189: "Możesz wybrać korzystanie z naszej witryny lub jej odwiedzanie bez ujawniania jakichkolwiek danych osobowych i transakcyjnych, ale musisz zarejestrować konto, aby skorzystać z pełnej obsługi. Jeśli podasz nam swoje dane, wyrażasz zgodę na ich przesyłanie i przechowywanie na naszych serwerach.",
    setup190: "51shopy zbiera dane osobowe, które podajesz podczas korzystania ze strony internetowej, w tym imię i nazwisko, dane kontaktowe, adres e-mail, nazwę konta i hasło 51shopy oraz inne informacje wymagane do utworzenia konta. Oprócz danych osobowych, które możemy zbierać i przetwarzać podczas rejestracji, zbieramy, przechowujemy i przetwarzamy również następujące informacje o naszych użytkownikach na 51shopy:",
    setup191: "1) Informacje o zakupie",
    setup192: "2) Informacje o koncie usługi",
    setup193: "3) Informacje dotyczące płatności (czas płatności, kwota płatności, kanał płatności itp.)",
    setup194: "4) Informacje o historii przeglądania wyszukiwania (treść wyszukiwania, zachowanie kliknięcia linku, historia przeglądania, historia wyświetlania kliknięć itd.)",
    setup195: "5) Pliki cookie i inne informacje komputerowe",
    setup196: "Nawiązaliśmy współpracę z Microsoft Clarity i Microsoft Advertising, aby rejestrować sposób korzystania z naszej witryny i interakcji z nią za pomocą metryk behawioralnych, map cieplnych i powtórek sesji w celu ulepszania i promowania naszych produktów/usług. Dane dotyczące korzystania z witryny są rejestrowane za pomocą plików cookie własnych i zewnętrznych oraz innych technologii śledzenia w celu określenia popularności produktów/usług i aktywności online. Ponadto wykorzystujemy te informacje do optymalizacji witryny, celów związanych z oszustwami/bezpieczeństwem i reklamą. Aby uzyskać więcej informacji na temat sposobu gromadzenia i wykorzystywania danych przez firmę Microsoft, odwiedź witrynę",
    setup197: "Oświadczenie o ochronie prywatności firmy Microsoft",
    setup198: "2. Jak wykorzystujemy Twoje dane osobowe?",
    setup199: "Nie będziemy sprzedawać ani ujawniać danych osobowych żadnego użytkownika i dążymy do ochrony Twoich danych i prywatności. Wykorzystamy Twoje dane, aby zapewnić Ci lepsze usługi, w tym:",
    setup200: "1) Skontaktujemy się z Tobą za pośrednictwem poczty elektronicznej i zapewnimy Ci szereg naszych usług, w tym usługi doradcze, usługi informacyjne dotyczące zamówień, usługi informacyjne dotyczące pakietów, usługi posprzedażowe dotyczące produktów itp.",
    setup201: "2) Informować Cię o działaniach na platformie za pośrednictwem poczty e-mail, poczty wewnętrznej itp., w tym udostępniać Ci kupony, rabaty na wysyłkę i specjalne promocje, a także zapewniać Ci możliwości korzystania z usług stron trzecich.",
    setup202: "3) Gdy przeszukujesz i przeglądasz linki naszych partnerów handlowych na 51shopy, Twój identyfikator użytkownika 51shopy, powiązane zachowania operacyjne i informacje (treść wyszukiwania, zachowanie kliknięcia linku, historia przeglądania, historia kliknięcia widoku itd.) zostaną dostarczone do źródła linku zachowania operacyjnego, dzięki czemu my i nasi partnerzy handlowi będziemy mogli współpracować, aby zapewnić Ci wysokiej jakości i wydajne usługi. Możesz kliknąć, aby wyświetlić partnerów handlowych 51shopy (www.taobao.com, www.1688.com).",
    setup203: "Zgodnie z przepisami prawa, regulacjami i normami krajowymi, w następujących okolicznościach partnerzy nie potrzebują Twojego upoważnienia ani zgody na wykorzystanie, przekazanie lub ujawnienie Twoich danych osobowych:",
    setup204: "1) Zgodnie z obowiązkowymi wymogami ustaw, rozporządzeń, organów administracyjnych i sądowych oraz innymi obowiązkami prawnymi;",
    setup205: "2) W zakresie dozwolonym przez przepisy prawa, jest to konieczne w celu ochrony interesu publicznego, bezpieczeństwa mienia oraz ochrony Ciebie lub innych użytkowników 51shopy, 51shopy, podmiotów stowarzyszonych lub partnerów 51shopy przed szkodami;",
    setup206: "3) Konieczne do realizacji podstawowych funkcji naszych produktów i/lub usług lub do świadczenia potrzebnych Ci usług;",
    setup207: "4) Przetwarzać Twoje dane osobowe ujawnione przez Ciebie lub inne dane osobowe ujawnione zgodnie z prawem (takie jak dane osobowe ujawnione zgodnie z prawem w doniesieniach prasowych, ujawnieniach informacji rządowych lub innych kanałach) w rozsądnym zakresie;",
    setup208: "5) Rozwiązuj spory i kontrowersje między Tobą a innymi zgodnie ze swoimi potrzebami;",
    setup209: "6) Przestrzegać stosownych umów podpisanych z Tobą (w tym umów elektronicznych online i odpowiednich zasad dotyczących platform) lub innych dokumentów prawnych;",
    setup210: "7) Używaj w oparciu o interesy społeczne i zagrożenia zdrowia publicznego oraz zgodnie z przepisami prawa i regulacjami.",
    setup211: "W powyższych celach masz również prawo anulować to powiadomienie w dowolnym momencie. Możesz zalogować się na stronie 51shopy i ustawić je samodzielnie w funkcji niestandardowej.",
    setup212: "Pamiętaj, że nie będziemy udostępniać Twoich danych osobowych żadnym reklamodawcom, chyba że uzyskamy Twoją zgodę. Nie będziemy żądać ani udostępniać danych osobowych dzieciom lub innym osobom niezdolnym do czynności prawnych bez zgody, wiedzy i obecności ich opiekunów prawnych.",
    setup213: "Niniejszym potwierdzasz, udostępniasz i przekazujesz zanonimizowane dane osobowe oraz zapewniasz, że odbiorca danych nie może przywrócić i ponownie zidentyfikować podmiotu danych osobowych, co nie stanowi udostępniania, przekazywania i publicznego ujawniania danych osobowych światu zewnętrznemu. Przechowywanie i przetwarzanie takich danych nie wymaga powiadomienia Ciebie i Twojej zgody.",
    setup214: "Możemy powierzyć autoryzowanym partnerom przetwarzanie Twoich danych osobowych, aby mogli oni świadczyć Ci określone usługi lub wykonywać określone funkcje w naszym imieniu. Powierzymy przetwarzanie Twoich danych wyłącznie w uzasadnionych, właściwych, koniecznych, konkretnych i jasnych celach określonych w niniejszej polityce, a autoryzowani partnerzy mogą uzyskać dostęp wyłącznie do informacji niezbędnych do wykonywania swoich obowiązków. 51shopy nie udostępni Twojego adresu e-mail, nazwy konta i hasła witryny 51shopy, danych kontaktowych ani innych prywatnych informacji naszym partnerom.",
    setup215: "3. Jak długo będziemy przechowywać Twoje dane?",
    setup216: "Po pomyślnej rejestracji konta 51shopy, Twoje dane osobowe zostaną trwale zapisane. Jeśli chcesz anulować konto lub usunąć dane osobowe, skontaktuj się z obsługą klienta online.",
    setup217: "Zgodnie z RODO administratorzy i podmioty przetwarzające dane są zobowiązani do zwrotu lub usunięcia wszystkich danych osobowych po zakończeniu usługi lub wygaśnięciu umowy, chyba że istnieje prawny wymóg przechowywania danych.",
    setup218: "4. Jak chronimy Twoje dane osobowe",
    setup219: "Podejmiemy wszelkie rozsądne i wykonalne środki w celu ochrony Twoich danych osobowych. Podejmiemy wszelkie rozsądne i wykonalne środki w celu zapewnienia, że ​​nie zostaną zebrane żadne nieistotne dane osobowe.",
    setup220: "5. Aktualizacja zasad",
    setup221: "Aby zapewnić Ci lepsze doświadczenie produktu i usługi, nieustannie pracujemy nad udoskonalaniem naszych produktów, usług i technologii. Gdy nowe usługi i procesy biznesowe ulegną zmianie, możemy zaktualizować naszą politykę prywatności, aby poinformować Cię o konkretnych zmianach. Prosimy o regularne sprawdzanie tej strony i przestrzeganie najnowszych zasad na stronie. Po opublikowaniu najnowszych zasad będą one dla Ciebie wiążące.",
    setup222: "6. Skontaktuj się z nami",
    setup223: "Jeśli masz jakiekolwiek pytania dotyczące niniejszej polityki prywatności, skontaktuj się z nami: ",
    setup224: "Przed zarejestrowaniem się jako użytkownik przeczytaj uważnie Warunki korzystania z usługi 51shopy i upewnij się, że w pełni rozumiesz te warunki. Przeczytaj uważnie i wybierz, czy zaakceptować, czy nie zaakceptować Warunków korzystania z usługi 51shopy, w szczególności warunki wyłączenia lub ograniczenia odpowiedzialności, obowiązującego prawa i rozstrzygania sporów. Jeśli nie zaakceptujesz Warunków korzystania z usługi 51shopy, nie masz prawa do rejestracji, logowania ani korzystania z usług 51shopy. Twoja rejestracja, logowanie i korzystanie będą uważane za akceptację Warunków korzystania z usługi 51shopy i Twoją zgodę na związanie się Warunkami korzystania z usługi 51shopy.",
    setup225: "Warunki korzystania z usługi 51shopy określają prawa i obowiązki użytkownika i 51shopy dotyczące usług 51shopy (zwanych dalej „Usługami”). Warunki korzystania z usługi 51shopy mogą być aktualizowane przez 51shopy w dowolnym momencie. Zaktualizowane Warunki korzystania z usługi 51shopy zastąpią oryginalne warunki po ich opublikowaniu i upublicznieniu bez dalszego powiadomienia. Najnowszą wersję Warunków korzystania z usługi 51shopy można sprawdzić na platformie 51shopy. Zaleca się również, aby być na bieżąco z zaktualizowanymi Warunkami korzystania z usługi 51shopy, aby uniknąć niepotrzebnych nieporozumień i sporów. Po zmianie Warunków korzystania z usługi 51shopy, jeśli nie akceptujesz zmienionych warunków, natychmiast zaprzestań korzystania z usług świadczonych przez 51shopy. Dalsze korzystanie z usług świadczonych przez 51shopy będzie uważane za akceptację zmienionych Warunków korzystania z usługi 51shopy.",
    setup226: "1. Zakres stosowania niniejszych Warunków korzystania z usługi",
    setup227: "Prawa własności i eksploatacji odpowiednich usług zarejestrowanych użytkowników należą do . Usługi świadczone muszą być wdrażane zgodnie z zasadami, warunkami i specyfikacjami operacyjnymi usług wydanymi przez niego, co oznacza również, że odpowiedni użytkownicy osiągnęli porozumienie z 51shopy i zaakceptowali wszystkie warunki usług.",
    setup228: "2. Gromadzenie i wykorzystywanie informacji",
    setup229: "Kiedy korzystasz z usług 51shopy, możemy potrzebować zbierać i wykorzystywać następujące dwa rodzaje Twoich danych osobowych:",
    setup230: "1. Aby zapewnić Ci podstawowe funkcje naszych usług, musisz upoważnić nas do zbierania i wykorzystywania niezbędnych informacji. Jeśli odmówisz podania odpowiednich informacji, nie będziesz mógł się zarejestrować, zalogować ani korzystać z naszych usług normalnie;",
    setup231: "2. Aby zapewnić Ci dodatkowe funkcje naszych usług, możesz wyrazić zgodę lub nie na informacje, które zbieramy i wykorzystujemy. Jeśli odmówisz ich podania, nie będziesz mógł korzystać z odpowiednich dodatkowych funkcji ani osiągnąć zamierzonych przez nas efektów funkcjonalnych, a korzystanie z naszych podstawowych funkcji nie będzie miało wpływu na Twoje korzystanie z nich.",
    setup232: "Chronimy Twoje prawo do wiedzy i prawo do wyboru podczas instalacji lub użytkowania zgodnie z prawem. Kiedy korzystasz z usług 51shopy, usługi obejmujące funkcje udostępniane na Twoim urządzeniu wymagają Twojej uprzedniej zgody. Po Twoim potwierdzeniu 51shopy ma prawo włączyć niezbędne funkcje pomocnicze, takie jak zbieranie lokalizacji geograficznej, odczytywanie książki adresowej, korzystanie z aparatu i włączanie usług nagrywania.",
    setup233: "Zbierane i wykorzystywane informacje obejmują, ale nie ograniczają się do imienia użytkownika, danych kontaktowych i innych podstawowych informacji. Użytkownik zgadza się, że wykorzystanie tych informacji podlega postanowieniom Artykułu 3 „Ochrona informacji użytkownika.",
    setup234: "3. Ochrona informacji użytkownika",
    setup235: "Nie ujawnimy ani nie udostępnimy Twoich danych osobowych osobom trzecim, chyba że:",
    setup236: "1. Udostępnianie niezbędne do wypełnienia obowiązków prawnych;",
    setup237: "2. Udostępnianie za Twoją zgodą;",
    setup238: "4. Prawa i obowiązki użytkownika",
    setup239: "1. Masz prawo zalogować się na stronie 51shopy, aby przeglądać, poprawiać i uzupełniać swoje dane osobowe.",
    setup240: "2. Masz prawo skontaktować się z obsługą klienta online, aby anulować swoje konto. Po anulowaniu konta zaprzestaniemy świadczenia Ci usług i usuniemy lub zanonimizujemy Twoje dane osobowe zgodnie z wymogami odpowiednich przepisów.",
    setup241: "3. W niektórych funkcjach biznesowych możemy podejmować decyzje wyłącznie w oparciu o zautomatyzowane mechanizmy podejmowania decyzji, w tym algorytmy, które nie są wykonywane przez człowieka. Jeśli decyzje te mają wpływ na Twoje prawa, możesz skontaktować się z nami za pośrednictwem obsługi klienta.",
    setup242: "4. Wszystkie informacje, które przekazujesz 51shopy, muszą być prawdziwe, dokładne i nie wprowadzać w błąd.",
    setup243: "Rozumiesz i zgadzasz się, że jesteś zobowiązany do zachowania autentyczności i ważności informacji, które podajesz.",
    setup244: "5. Nie możesz używać swojego zarejestrowanego konta ani usług 51shopy do tworzenia, przesyłania, kopiowania, publikowania ani rozpowszechniania treści, które zakłócają normalne działanie 51shopy lub naruszają uzasadnione prawa i interesy innych użytkowników lub osób trzecich.",
    setup245: "6. Nie możesz kopiować, plagiatować, sprzedawać, odsprzedawać ani używać do żadnych innych celów komercyjnych żadnej części usługi 51shopy ani treści używanej lub uzyskanej za pośrednictwem usługi 51shopy.",
    setup246: "7. Ponosisz wyłączną odpowiedzialność za autentyczność, legalność, dokładność i ważność wszelkich informacji przesyłanych za pośrednictwem Twojego konta 51shopy lub usług 51shopy. Wszelka odpowiedzialność prawna związana z wszelkimi przesyłanymi przez Ciebie informacjami leży po Twojej stronie i nie ma nic wspólnego z 51shopy. Pokryjesz wszelkie straty poniesione przez 51shopy lub osoby trzecie, a 51shopy zastrzega sobie prawo do pociągnięcia odpowiednich użytkowników i użytkowników do odpowiedzialności.",
    setup247: "8. Ponosisz pełną odpowiedzialność za konsekwencje wszystkich działań podejmowanych na Twoim koncie (w tym, ale nie wyłącznie, podpisywanie różnych umów online, publikowanie informacji, kupowanie towarów i usług oraz ujawnianie informacji).",
    setup248: "5. Przechowywanie informacji",
    setup249: "51shopy” nie ma górnego limitu ilości przesyłanych informacji. Podjęliśmy rozsądne i wykonalne środki bezpieczeństwa, które spełniają standardy branżowe, aby chronić Twoje informacje i zapobiegać dostępowi do danych osobowych, ich ujawnianiu, wykorzystywaniu, modyfikowaniu, uszkodzeniu lub utracie bez upoważnienia. Należy również odpowiednio chronić swoje dane osobowe i udostępniać je innym osobom tylko wtedy, gdy jest to konieczne. Nie ufaj innym narzędziom handlowym, aby uniknąć kradzieży informacji lub nawet oszustwa online.",
    setup250: "6. Zastrzeżenie odpowiedzialności",
    setup251: "1.51shopy dołoży wszelkich starań, aby odtworzyć rzeczywistą sytuację przedstawioną w informacjach o produkcie, ale ze względu na wpływ różnych czynników, takich jak otoczenie, kąt fotografowania, różnice w sprzęcie itp. podczas fotografowania produktu, nie możemy zagwarantować, że produkt jest dokładnie taki sam jak oryginał.",
    setup252: "2.51shopy kupuje określone produkty na podstawie platformy określonej przez użytkownika. Jeśli platforma, którą wskazałeś, jest niedostępna, cena ulega zmianie, dostawa jest opóźniona, rzeczywisty produkt nie odpowiada informacjom o produkcie na stronie internetowej, produkt jest nieprawidłowy lub inne czynniki siły wyższej uniemożliwiają normalny zakup, skontaktujemy się z Tobą w odpowiednim czasie. Dlatego „51shopy” nie ponosi żadnej odpowiedzialności za poniesione przez Ciebie straty.",
    setup253: "3. Jeśli produkty zakupione w 51shopy wiążą się z problemami posprzedażowymi (takimi jak brak towaru, uszkodzenie, wady itp.), zajmiemy się nimi w odpowiednim czasie.",
    setup254: "4. 51shopy nie ponosi żadnej odpowiedzialności za straty lub konsekwencje spowodowane przez Twoje proaktywne ujawnienie Twojego konta 51shopy lub przez ataki, oszustwa itp. przez innych. Powinieneś dochodzić odszkodowania od naruszyciela za pomocą środków prawnych lub innych środków.",
    setup255: "7. Zachowanie zabronione",
    setup256: "Nie możesz używać usług 51shopy do następujących działań:",
    setup257: "(1) Naruszenie jakiegokolwiek prawa, statutu, dekretu lub rozporządzenia.",
    setup258: "(2) W grę wchodzą następujące transakcje:",
    setup259: "(a) narkotyki, sterydy, niektóre leki kontrolowane lub inne produkty, które mogą zagrażać bezpieczeństwu konsumentów;",
    setup260: "(b) przyrządy do zażywania narkotyków;",
    setup261: "(c) Papierosy;",
    setup262: "(d) niedozwolona marihuana lub inne rośliny psychoaktywne;",
    setup263: "(e) subskrypcja produktów odżywczych, witamin, suplementów, ziół i naturalnych produktów zdrowotnych;",
    setup264: "(f) jakikolwiek materiał, który podżega, nakłania, pomaga lub kieruje innymi do angażowania się w działania niezgodne z prawem;",
    setup265: "(g) przedmioty skradzione, w tym przedmioty cyfrowe i wirtualne;",
    setup266: "(h) materiały podżegające do nienawiści, przemocy, rasizmu lub innych form nietolerancji albo wykorzystujące działalność przestępczą;",
    setup267: "(i) uważane za obsceniczne;",
    setup268: "(j) jakikolwiek materiał naruszający lub łamiący prawa autorskie, znaki towarowe, prawo do rozgłosu lub prywatności lub jakiekolwiek inne prawa własności na mocy przepisów dowolnej jurysdykcji;",
    setup269: "(k) określone materiały lub usługi pornograficzne;",
    setup270: "(l) amunicja, broń lub niektóre części lub akcesoria broni, lub",
    setup271: "(m) Określona broń lub noże regulowane przez obowiązujące prawo.",
    setup272: "(3) Dotyczy następujących transakcji:",
    setup273: "(a) Ujawnienie danych osobowych osób trzecich z naruszeniem obowiązujących przepisów prawa;",
    setup274: "(b) wspiera piramidy finansowe, schematy Ponziego, schematy macierzowe, inne schematy szybkiego wzbogacenia się lub niektóre schematy wielopoziomowe;",
    setup275: "(c) transakcje związane z zakupem rent lub kontraktów loteryjnych, systemami zakupu depozytów przedpłaconych, bankowością offshore lub transakcjami finansowania lub refinansowania zadłużenia z tytułu kart kredytowych;",
    setup276: "(d) sprzedaż czegoś zanim sprzedawca przejmie nad tym kontrolę lub posiadanie;",
    setup277: "(e) podmioty przetwarzające płatności pobierają płatności w imieniu sprzedawców;",
    setup278: "(f) w związku ze sprzedażą czeków podróżnych lub przekazów pieniężnych;",
    setup279: "(g) obejmujące wymianę walut lub operacje realizacji czeków;",
    setup280: "(h) obejmuje określone usługi naprawy kredytu lub rozliczeń długów, transakcje kartą kredytową lub działania ubezpieczeniowe lub",
    setup281: "(i) obejmuje dokonywanie lub otrzymywanie płatności związanych z łapówkarstwem lub korupcją.",
    setup282: "(4) Wiąże się ze sprzedażą produktów lub usług, które zdaniem agencji rządowych mogą być oszustwem.",
    setup283: "Ponosisz prawną odpowiedzialność za korzystanie z usług 51shopy, w tym, ale nie wyłącznie, odszkodowanie za straty poniesione przez naruszoną stronę, a po tym, jak 51shopy poniesie najpierw odpowiedzialność prawną, taką jak kary administracyjne lub odszkodowanie za naruszenie spowodowane zachowaniem użytkownika, zapłacisz 51shopy równą kwotę odszkodowania i innych strat poniesionych przez 51shopy w wyniku tego.",
    setup284: "8. Odpowiedzialność odszkodowawcza",
    setup285: "1. Jeśli Twoje działania spowodują, że 51shopy i/lub jego podmioty stowarzyszone poniosą straty (w tym bezpośrednie straty ekonomiczne, utratę dobrego imienia i pośrednie straty ekonomiczne, takie jak odszkodowanie, ugoda, honoraria adwokackie, ubezpieczenie na wypadek utraty własności, opłaty sądowe itp.), musisz zrekompensować 51shopy i/lub jego podmioty stowarzyszone wszelkie straty.",
    setup286: "2. Jeśli Twoje działania spowodują, że 51shopy i/lub jego podmioty stowarzyszone zostaną pozwane przez osobę trzecią (w tym, ale nie wyłącznie, sprzedawców na Taobao, 1688 i innych platformach), 51shopy i/lub jego podmioty stowarzyszone mogą odzyskać od Ciebie wszystkie straty po przyjęciu zobowiązań, takich jak rekompensata pieniężna na rzecz osoby trzeciej.",
    setup287: "9. Prawo właściwe i jurysdykcja",
    setup288: "1. Niniejsza Umowa o świadczenie usług i każda odrębna umowa, na podstawie której świadczymy Ci usługi, podlegają prawu Hongkongu i są zgodnie z nim interpretowane.",
    setup289: "2. Wszelkie spory wynikające z korzystania z usług 51shopy i spory związane z usługami 51shopy będą rozstrzygane w drodze negocjacji między 51shopy a Tobą. Jeśli negocjacje nie powiodą się, każda ze stron może złożyć pozew w sądzie właściwym dla miejsca, w którym podpisano tę umowę.",
    setup290: "Oto harmonogram wysyłki z magazynu (przesyłek do magazynu dostawcy usług logistycznych)/odbioru przez dostawcę usług logistycznych, wyłącznie w celach informacyjnych (rzeczywisty harmonogram podlega ustaleniom każdego dostawcy usług logistycznych):",
    setup291: "Czas dostarczenia/odbioru przesyłki:",
    setup292: "Gdy status paczki w magazynie 51shopy to “Spakowane”, magazyn i firma logistyczna zorganizują dostawę/odbiór w ustalonym czasie (firma logistyczna jest zamknięta w weekendy i święta, a odbiór zostanie przełożony).",
    setup293: "Trasa",
    setup294: "Harmonogram wysyłania/odbioru (czas pekiński)",
    setup295: "GD-EMS",
    setup296: "Odbiór od poniedziałku do niedzieli",
    setup297: "GD-EUB",
    setup298: "Odbiór od poniedziałku do niedzieli",
    setup299: "GD-E-EMS",
    setup300: "Odbiór od poniedziałku do niedzieli",
    setup301: "EUB-T",
    setup302: "Odbiór od poniedziałku do niedzieli",
    setup303: "DHL Express",
    setup304: "Odbiór od poniedziałku do soboty",
    setup305: "DHL Heavy Cargo Standard Express",
    setup306: "Odbiór od poniedziałku do soboty",
    setup307: "Europejska specjalna linia DHL",
    setup308: "Wysyłka od poniedziałku do niedzieli (dostarczona do magazynu dostawcy usług logistycznych)",
    setup309: "Linia amerykańska (mała)",
    setup310: "Wysyłka od poniedziałku do niedzieli (dostarczona do magazynu dostawcy usług logistycznych)",
    setup311: "British Line (Mała)",
    setup312: "Wysyłka od poniedziałku do niedzieli (dostarczona do magazynu dostawcy usług logistycznych)",
    setup313: "Korea EMS",
    setup314: "Wysyłka z naszego magazynu każdego dnia",
    setup315: "Paczka pocztowa PDB",
    setup316: "Haibao",
    setup317: "Europejskie Koleje",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "dedykowana linia Aramex",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Brytyjska linia",
    setup334: "NH-EMS",
    setup335: "Europejska linia wolnocłowa",
    setup336: "Linia amerykańska",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy to platforma, która zapewnia chińskie usługi zakupów i przekazywania produktów, zapewniając użytkownikom wyszukiwanie informacji o produktach, zakupy i usługi przekazywania. W tym okresie 51shopy zapewnia podstawowe usługi inspekcji produktów, potwierdzanie komunikacji ze sprzedawcami i usługi posprzedażowe w celu ochrony Twoich praw i interesów prawnych oraz zapewnienia Ci doświadczenia zakupowego.",
    setup340: "Jeśli okaże się, że zakupiony towar jest podrobiony lub gorszej jakości, skontaktuj się z naszym działem obsługi klienta lub wyślij wiadomość e-mail na adres",
    setup341: "1. Odbiór i kontrola: Po sprawdzeniu jakości produktu i umieszczeniu go w magazynie 51shopy lub po otrzymaniu przesyłki, jeśli znajdziesz jakiekolwiek problemy z jakością produktu lub masz wątpliwości co do jego autentyczności, skontaktuj się z obsługą klienta tak szybko, jak to możliwe i przedstaw odpowiednie dowody.",
    setup342: "2. Materiały reklamacyjne: Dostarcz formularz zamówienia, paragon za płatność, opis produktu i dowody na podróbki lub produkty gorszej jakości.",
    setup343: "3. Po otrzymaniu materiałów dotyczących Twojej skargi nasz zespół obsługi klienta zapozna się z Twoimi szczegółami i pomoże Ci w komunikacji ze sprzedawcą w celu rozwiązania problemu i walki o Twoje prawa.",
    setup344: "Należy pamiętać, że ze względu na autentyczność produktu, może być wymagana dalsza profesjonalna ocena i procedury prawne. Jeśli wymagana jest profesjonalna agencja oceniająca, opłata za ocenę zostanie pokryta przez Ciebie. Aby chronić prawa i interesy wszystkich stron, zalecamy wybór formalnych kanałów i renomowanych sprzedawców podczas zakupów, aby zmniejszyć ryzyko zakupu podróbek.",
    setup345: "Jaka jest 14-dniowa gwarancja zwrotu/wymiany?",
    setup346: "Pięciodniowa gwarancja zwrotu i wymiany to specjalna usługa posprzedażowa (w tym sama usługa i wsparcie techniczne) świadczona przez sprzedawców zewnętrznych na rzecz konsumentów. W ciągu 14 dni od podpisania odbioru towarów (tj. w ciągu 14 dni od umieszczenia towarów w magazynie) kupujący mogą zwrócić lub wymienić zakupione towary zgodnie z tą zasadą i odpowiednimi zasadami wydanymi przez platformę zewnętrzną.",
    setup347: "Jak mogę ustalić, czy produkt kwalifikuje się do gwarancji zwrotu/wymiany?",
    setup348: "Produkty albo kwalifikują się do 14-dniowej bezpłatnej usługi zwrotu i wymiany, albo 'nie kwalifikują się' do 14-dniowej bezpłatnej usługi zwrotu i wymiany",
    setup349: "Czy jest dostępny?",
    setup350: "Typ",
    setup351: "Na przykład",
    setup352: "Niedostępne",
    setup353: "Ustalono na podstawie informacji dostarczonych przez sprzedawcę. Jeśli nie będziemy w stanie potwierdzić, będziemy negocjować ze sprzedawcą zwrot/wymianę, ale ostateczny wynik zależy od decyzji sprzedawcy.",
    setup354: "Dostosowywanie",
    setup355: "Produkty o niestandardowym projekcie",
    setup356: "Wyraźnie nie obsługuje zwrotów i wymian",
    setup357: "Promuj wadliwe produkty",
    setup358: "Produkty, których opakowanie, etykiety i akcesoria zostały usunięte na prośbę użytkownika",
    setup359: "Metka od ubrania jest zerwana",
    setup360: "Gazety i czasopisma",
    setup361: "Zaprenumerowane książki i czasopisma",
    setup362: "Produkty używane",
    setup363: "Produkty spoza Chin kontynentalnych",
    setup364: "Produkty zakupione za granicą oraz w Hongkongu i Makau",
    setup365: "Bielizna",
    setup366: "Bielizna, skarpetki, legginsy",
    setup367: "Produkty dla dorosłych",
    setup368: "Inne kwestie określone przez sprzedawcę",
    setup369: "Przestrzegaj zasad sprzedawcy",
    setup370: "Jedzenie",
    setup371: "Ciasteczka, cukierki itp.",
    setup372: "Książki (≥15 książek)",
    setup373: "Nie mniej niż 15 książek",
    setup374: "Przedmioty, które zostały otwarte i muszą spełniać „specjalne standardy” dotyczące opakowań zwrotnych.",
    setup375: "W przypadku produktów do uszczelniania należy zapoznać się z załączoną tabelą",
    setup376: "Dostępne",
    setup377: "W przypadku wniosków o zwrot/wymianę złożonych w ciągu 14 dni od ich otrzymania, rozpatrzymy je zgodnie ze standardowymi procedurami.",
    setup378: "Gdy produkt spełnia wszystkie poniższe wymagania:",
    setup379: "1. Sprzedawca zapewnia gwarancję zwrotu;",
    setup380: "2. W stanie nadającym się do odsprzedaży, zgodnie z wymaganiami sprzedawcy;",
    setup381: "3. Czas przechowywania nie jest dłuższy niż 14 dni.",
    setup382: "W przypadku produktów, które oferują bezpłatną wysyłkę, będziesz odpowiedzialny za koszty wysyłki, gdy zwrócisz produkt. W przypadku produktów, które nie oferują bezpłatnej wysyłki, będziesz odpowiedzialny za koszty wysyłki, gdy sprzedawca wyśle ​​produkt do naszego magazynu i gdy zwrócisz produkt sprzedawcy.",
    setup383: "Jak ubiegać się o usługę zwrotu/wymiany",
    setup384: "W ciągu 14 dni od zmiany statusu zamówienia na „Inwentarz” (licząc od następnej godziny po zmianie statusu na „Inwentarz”, 14 dni = 336 godzin), możesz złożyć wniosek o usługę zwrotu i wymiany na stronie. Wnioski mogą nie zostać przyjęte po upływie terminu.",
    setup385: "Środki ostrożności i często zadawane pytania",
    setup386: "Uwagi:",
    setup387: "Całkowita kwota zwrotu/wymiany jest oparta na rzeczywistej cenie produktu, jaką zapłaciłeś",
    setup388: "Możemy zwrócić/wymienić produkty tylko wtedy, gdy sprzedawca wyrazi na to zgodę",
    setup389: "Po złożeniu wniosku o usługę zwrotu/wymiany, upewnij się, że na Twoim koncie jest wystarczająca ilość środków, aby zapłacić za wysyłkę zwrotną i opłatę za usługę.",
    setup390: "Prosimy zapoznać się z poniższą tabelą dotyczącą wymagań dotyczących opakowań zwrotnych niektórych produktów. Jeśli wymagania nie zostaną spełnione, nie będziesz mógł zwrócić/wymienić produktu.",
    setup391: "Standardy specjalne",
    setup392: "Kategoria produktu",
    setup393: "Specjalne standardy",
    setup394: "Nowe buty sportowe",
    setup395: "Zapięcia antykradzieżowe (jeśli występują) i naklejki zabezpieczające przed ingerencją nie zostały przecięte/usunięte i są w pełni funkcjonalne.",
    setup396: "Detergent / Tampon / Papier / Perfumy",
    setup397: "Jeżeli występują, jednorazowe, szczelnie zamknięte pojemniki na produkty do pielęgnacji osobistej, muszą pozostać szczelnie zamknięte.",
    setup398: "Pielęgnacja włosów/Peruki",
    setup399: "Jednorazowe, szczelnie zamknięte opakowania produktów do pielęgnacji włosów (jeśli występują) muszą pozostać szczelnie zamknięte.",
    setup400: "Pielęgnacja skóry/Pielęgnacja ciała/Olejki eteryczne",
    setup401: "Jednorazowe, szczelne opakowanie produktu (jeśli istnieje) musi pozostać szczelne",
    setup402: "Kosmetyki/Perfumy/Narzędzia kosmetyczne",
    setup403: "Produkty cyfrowe/sprzęt AGD (z wyłączeniem aparatów fotograficznych i dużych urządzeń)",
    setup404: "1. Licencja dostępu do Internetu nie jest uszkodzona (zniszczona).",
    setup405: "2. Brak uszkodzeń spowodowanych przez wodę.",
    setup406: "Aparat cyfrowy/Lustrzanka/Aparat",
    setup407: "Spust migawki aparatu SLR nie powinien być naciskany więcej niż 20 razy.",
    setup408: "Duże urządzenia AGD",
    setup409: "1. Telewizor LCD, klimatyzator: Jeszcze nie zainstalowany na ścianie, dostępne jest proste debugowanie.",
    setup410: "2. Pralka: nie była jeszcze używana z wodą.",
    setup411: "Modele / Urządzenia peryferyjne anime / Urządzenia peryferyjne anime / Produkty do gier RPG / Gry planszowe",
    setup412: "Taśma i plomby plastikowe (jeśli występują) na modelach, figurkach, modelach żołnierzy, BJD i innych produktach nie mogą zostać usunięte.",
    setup413: "Elementy elektroniczne",
    setup414: "1. Spawanie jest zabronione.",
    setup415: "2. Układ scalony nigdy nie był montowany na żadnej bazie IC.",
    setup416: "3. Jednorazowe, zamknięte opakowania materiałów eksploatacyjnych, takich jak smar termiczny/pasta termiczna, klej elektroniczny/klej do zalewania/uszczelniacz/klej, klej przewodzący, tusz przewodzący itp. muszą być przechowywane w zamkniętych opakowaniach.",
    setup417: "Podkategoria „Oprogramowanie do gier” w kategorii pierwszego poziomu „Gry wideo/Akcesoria/Gry/Przewodniki po grach",
    setup418: "Karma dla zwierząt, produkty zdrowotne i leki w kategorii pierwszego poziomu „Zwierzęta domowe/Karma i artykuły dla zwierząt",
    setup419: "Książki/Czasopisma",
    setup420: "1. Jednorazowe, zapieczętowane opakowanie produktu (jeśli istnieje) musi pozostać zapieczętowane",
    setup421: "2. Produkt nie powinien mieć żadnych śladów pozostawionych przez składanie, plamy wody, brud, atrament lub czytanie.",
    setup422: "Kategoria drugorzędna “Produkty dla zdrowia zwierząt/Leki weterynaryjne” w ramach kategorii głównej „Hodowla zwierząt/Produkty rolne”",
    setup423: "Jednorazowe, zapieczętowane opakowania (jeśli występują) produktów takich jak żywność (w tym suplementy), kosmetyki, wyroby medyczne, środki antykoncepcyjne, produkty do pielęgnacji ciała, produkty dla dorosłych, pieluchy dla dzieci, książki i produkty audiowizualne muszą pozostać zapieczętowane.",
    setup424: "Termin 'uszczelnienie' odnosi się do uszczelnienia lub plastikowego opakowania stosowanego przez producenta na opakowaniu produktu.",
    setup425: "Często zadawane pytania:",
    setup426: "1. Co powinienem zrobić, jeśli zamówienie, które nie jest objęte ”Gwarancją zwrotu i wymiany“, ma problemy posprzedażowe?",

    setup427: "Gdy występują problemy z jakością produktu, 51shopy zweryfikuje to ze sprzedawcą na podstawie rzeczywistej sytuacji, sformułuje ostateczne rozwiązanie i powiadomi użytkownika. Jeśli nie ma problemów z jakością produktu, zgodnie z zasadami platformy zewnętrznej, usługi zwrotu i wymiany nie mogą być świadczone. 51shopy dołoży wszelkich starań, aby komunikować się ze sprzedawcą w celu ochrony praw i interesów użytkowników.",
    setup428: "2. Kto odpowiada za wysyłkę w przypadku korzystania z „Gwarancji zwrotu/wymiany”? ",
    setup429: "Przed złożeniem wniosku o usługę zwrotu i wymiany, produkt musi być nowy i spełniać warunki odsprzedaży. Jeśli produkt nie ma problemów z jakością, koszt wysyłki ponosi użytkownik. Jeśli produkt ma problemy z jakością, sprzedawca pokryje koszt wysyłki po złożeniu wniosku przez użytkownika.",
    setup430: "3. Jeśli status zamówienia nie jest wysłany, czy jest jakaś opłata za usługę zwrotu?",
    setup431: "Nie martw się, w tym przypadku nie pobieramy opłat. Zostaniesz obciążony opłatą tylko wtedy, gdy prośba o zwrot spełni trzy warunki: po pierwsze, produkt nie ma problemów z jakością. Po drugie, produkt jest już dostępny w magazynie. Po trzecie, wykorzystałeś liczbę bezpłatnych zwrotów w tym miesiącu. Dlatego nie naliczymy Ci żadnych opłat, gdy produkt nie zostanie wysłany.",
    setup432: "E-mail:",
    setup433: "Tel.: +85251387262",
    setup434: "Adres: Pokój 341, 3/piętro, Publiczny Budynek Przemysłowy, 56 Hoi Yuen Road, Kwun Tong, Hongkong",
    setup435: "Obsługiwane przez 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Pomóc w przetwarzaniu",
    setup437: "Wczorajsza gorąca wyprzedaż",
    setup438: "Gorąca wyprzedaż",
    setup439: "Sprzedane",
    setup440: "Płatność nie powiodła się",
    setup441: "Czekam na zapłatę opłaty pocztowej",
    setup442: "Przesyłka opłacona, czekam na potwierdzenie z banku",
    setup443: "Opłata pocztowa opłacona",
    setup444: "Specyfikacje",
    setup445: "Rzeczywista płatność",
    setup446: "Zaleca się, aby dokładnie rozważyć anulowanie zamówienia. Platforma nie będzie odpowiedzialna za anulowanie zamówienia!",
    setup447: "Przełącz płatność",
    setup448: "Zapłać za przesyłkę",
    setup449: "Zamówienie w centrum handlowym",
    setup450: "Więcej",
    setup451: "Sklep",
    setup452: "Zak. zauf.",
    setup453: "Wydanie",
    setup454: "Sprzedaj",
    setup455: "Historia",
    setup456: "Zamówienie zakupu",
    setup457: "Kwota do zapłaty",
    setup458: "Wejdź do sklepu",
    setup459: "Zobacz więcej",
    setup460: "Zwiń",
    setup461: "Wejdź",
    setup462: "Produkt został wyprzedany.",
    setup463: "Polecamy następujące podobne produkty",
    setup464: "Podobne produkty",
    setup465: "Zastrzeżenie",
    setup467: "Opakowanie odnosi się do oryginalnego opakowania produktu. W przypadku kontroli, opakowanie logistyczne zostanie usunięte, z wyjątkiem samego produktu. Aby uniknąć uszkodzenia produktu, zachowane zostaną niezbędne materiały ochronne. Nie ponosimy odpowiedzialności, jeśli poprosisz o usunięcie opakowania.",
    setup468: "Krajowy kompleksowy przewóz towarów W przypadku towarów od tego samego sprzedawcy, odchylenie od ceny przewozu zostanie przez nas skorygowane.",
    setup469: "Do każdego produktu zrobimy dla Ciebie 3-7 zdjęć bezpłatnie. Jeśli masz dodatkowe wymagania dotyczące wykwintnych usług fotograficznych, możemy pobrać niewielką opłatę za usługę.",
    setup470: "Produkty niestandardowe nie podlegają zwrotom ani wymianie.",
    setup471: "W przypadku produktów zatwierdzonych do zwrotu i wymiany przez sprzedawcę, możesz złożyć wniosek o zwrot i wymianę w ciągu 14 dni od zmiany statusu zamówienia na „W magazynie”. Gdy poprosisz o zwrot i wymianę, musisz ponieść opłatę manipulacyjną w wysokości około 0,75 USD i koszty wysyłki krajowej za każdy inny zwrot produktu, łączna kwota wynosi około 3 USD.",
    setup472: "All",
    setup473: "Trasa pocztowa",
    setup474: "Opłata za wysyłkę",
    setup475: "Wymagane są informacje o długości, szerokości i wysokości opakowania",
    setup476: "Czas transportu",
    setup477: "dzień",
    setup478: "Wolne od podatku",
    setup479: "Można ubezpieczyć",
    setup480: "Estym. kosztów",
    setup481: "Pobierz rejestr haseł",
    setup482: "Kupiec",
    setup483: "Proszę",
    setup484: "Zapłać, w przeciwnym razie zamówienie zostanie anulowane",
    setup485: "Całkowita cena towarów",
    setup486: "Kwota zapłacona",
    setup487: "Zapłać teraz",
    setup488: "Saldo jest niewystarczające, proszę doładować i zapłacić",
    setup489: "Brak odpowiedniej metody płatności? Możesz najpierw spróbować zapłacić saldem",
    setup490: "Już w magazynie",
    setup491: "Wyceniono fracht",
    setup492: "Opłata za wysyłkę zapłacona",
    setup493: "Wysyłka niedostępna",
    setup494: "Kontynuuj płacenie",
    setup495: "Nr. zamówienia logistycznego międzynarodowego",
    setup496: "Nr. zamówienia logistyki krajowej",
    setup497: "Twoja przeglądarka nie obsługuje odtwarzacza wideo HTML5.",
    setup498: "Obsługuje tylko przesyłanie obrazów w formacie PNG i JPEG!",
    setup499: "Zakończono",
    setup500: "zwróć",
    setup501: "Nie masz uprawnień dostępu do tej strony",
    setup502: "Obliczanie transportu",
    setup503: "Współpracuj z wieloma firmami logistycznymi, aby zapewnić najkorzystniejsze rabaty",
    setup504: "Estym. kosztów",
    setup505: "Wyszukaj produkty",
    setup506: "Wyświetl produkty na podstawie kryteriów wyszukiwania",
    setup507: "Podstawowe informacje",
    setup508: "Wprowadź angielską nazwę",
    setup509: "Wprowadź chińską nazwę",
    setup510: "Przesłane filmy mogą być tylko w formacie MP4, WebM lub OGG!",
    setup511: "Rozmiar przesłanego filmu nie może przekraczać 2 MB!",
    setup512: "Czas trwania filmu nie może przekroczyć",
    setup513: "sekundy",
    setup514: "Nie można uzyskać czasu trwania filmu. Sprawdź, czy plik wideo nie jest uszkodzony",
    setup515: "dane",
    setup516: "",
    setup517: "Proszę wprowadzić kod SKU",
    setup518: "Proszę wprowadzić ilość",
    setup519: "Proszę podać cenę",
    setup520: "Wprowadź angielskie dane produktu",
    setup521: "Wprowadź chińskie dane produktu",
    setup522: "Uproszczony chiński",
    setup523: "hiszpański",
    setup524: "portugalski",
    setup525: "holenderski",
    setup526: "Polski",
    setup527: "niemiecki",
    setup528: "Francuski",
    setup529: "Włoski",
    setup530: "Włącz wiele specyfikacji",
    setup531: "Cena (CNY)",
    setup532: "Dodaj Zdj. Spec",
    setup533: "Dodaj Wart. Spec",
    setup534: "① Kliknij dwukrotnie, aby zmodyfikować, przeciągnij, aby zmienić kolejność",
    setup535: "Dodaj specyfikacje",
    setup536: "Ustawienia wsadowe",
    setup537: "Proszę opublikować na komputerze",
    setup538: "Nazwa",
    setup539: "Prześlij wideo produktu",
    setup540: "czas wejścia do magazynu",
    setup541: "czas wyjścia z magazynu",
    setup543: "Moje wydanie",
    setup544: "Przed opublikowaniem produktu należy uwierzytelnić się jako sprzedawca",
    setup545: "Przejdź do komputera, aby opublikować produkt",
    setup546: "destination",
    setup547: "United States of America",
    setup548: "Weight (grams)",
    setup549: "Product category",
    setup550: "Please select category",
    setup551: "length",
    setup552: "width",
    setup553: "height",
    setup554: "QUERY",
    setup555: "comprehensive",
    setup556: "Można ubezpieczyć",
    setup557: "duty-free",
    setup558: "shipping fee",
    setup559: "Empty package length, width, and height information",
    setup560: "Transport time",
    setup561: "days",
    setup562: "Cancel ustd payment successfully!",
    setup563: "dayReminder: Please select your destination country, and the system will search for available routes at this locations",
    setup564: "Package ograniczenia",
    setup565: "Minimalny limit wagi:",
    setup566: "Maksymalny limit wagi:",
    setup567: "Zasady rozliczania wagi objętościowej:",
    setup568: "Limit rozmiaru:",
    setup569: "Nie można wysłać",
    setup570: "Można wysłać",
    setup571: "Standardy opłat:",
    setup572: "jednostka wagi",
    setup573: "cena jednostkowa",
    setup574: "Opłata celna",
    setup575: "Koszt paliwa",
    setup576: "Opłata operacyjna",
    setup577: "Limit kredytowy tego banku jest niewystarczający, dlatego nie możesz wybrać tego banku!",
    setup578: "Saldo 51coinów jest niewystarczające, proszę doładować!",
    setup579: "uwaga",
    setup580: "Wybierz produkt, który chcesz usunąć!",
    setup581: "Zaloguj się za pomocą Google",
    setup582: "Pierwsze zdjęcie jest domyślnie główne. Przeciągnij, aby zmienić.",
    setup583: "Osiągnięto maksymalny limit przesyłania",
    setup584: "Zaloguj się za pomocą Telegramu",
    setup585: "Wyświetl logistykę",
    setup586: "Informacje logistyczne",
    setup587: "Modyfikuj numer zamówienia logistycznego",
    setup588: "Wiązany e-mail",
    setup589: "Proszę najpierw wiązać swój e-mail",
    setup590: "Możesz wprowadzić maksymalnie 2 typy specyfikacji!",
    setup591: "Wspólne szablony",
    setup592: "Wybierz model",
    setup593: "Anuluj",
    setup594: "Dodaj",
    setup595: "Proszę wybrać wartość specyfikacji",
    setup596: "Nie dodawaj wielokrotnie",
    setup597: "Skonfigurowano powszechnie używane szablony pomyślnie!",
    setup598: "SKU nie może być pusty",
    setup599: "Cena nie może być pusta",
    setup600: "Ilość nie może być pusta",
    setup601: "Nie można dodać tej samej wartości specyfikacji!",
    setup602: "① Kliknij dwukrotnie, aby zmodyfikować",
    setup603: "Proszę uzupełnić informacje dotyczące specyfikacji!",
    setup604: "Proszę wypełnić szczegóły produktu zarówno w języku chińskim uproszczonym, jak i angielskim!",
    setup605: "Modyfikacja zakończona sukcesem",
    setup606: "Pomyślnie dodano wartość specyfikacji!",
    setup607: "Ustaw jako zwykłe",
    setup608: "Wypełnij przynajmniej jedną wartość specyfikacji!",
    setup609: "Wprowadź uproszczony chiński",
    setup610: "Proszę wpisać język angielski",
    setup611: "Wprowadź język hiszpański",
    setup612: "Wprowadź język portugalski",
    setup613: "Wprowadź język holenderski",
    setup614: "Proszę wpisać język polski",
    setup615: "Proszę wpisać język niemiecki",
    setup616: "Proszę wpisać język francuski",
    setup617: "Wprowadź język włoski",
    setup618: "Automatyczne tłumaczenie",
    setup619: "Tłumaczenie",
    setup620: "Wszystkie inne",
    setup621: "INFORMACJE O WYSYŁCE",
    setup622: "Naszym celem jest oferowanie najlepszych opcji wysyłki, bez względu na to, gdzie mieszkasz. Dostarczamy do setek klientów na całym świecie każdego dnia i staramy się zapewnić Ci usługi na najwyższym poziomie.",
    setup623: "A.Czas realizacji zamówienia jest podzielony na dwie części:",
    setup624: "· Czas realizacji: 3-7 dni",
    setup625: "· Czas wysyłki: 14~30 dni",
    setup626: "B.Metody wysyłki",
    setup627: "C.Opłata za wysyłkę",
    setup628: "Prawa własności intelektualnej",
    setup629: "Transport lądowy/morski",
    setup630: "Czekam na odbiór",
    setup631:"Przyłączać",
    setup632: "Udostępnij swój kod partnerski",
    setup633: "Zaproszeni przez Ciebie znajomi potwierdzają, że otrzymali Twój kod sojuszu",
    setup634:"Otrzymaj prowizję partnerską",
    setup635:"Skopiuj ten adres URL i użyj go, aby przekierować użytkowników na stronę główną swojego identyfikatora afilianta",
    setup636: "Kopiuj adres URL",
    setup637: "Mój sojusz",
    setup638: "Rejestr",
    setup639:"Pobierz",
    setup640: "Często zadawane pytania dotyczące kapitału własnego",
    setup641:"Czym jest program partnerski?",
    setup642:"51Shopy to projekt współdzielenia i zarabiania zainicjowany przez wszystkich użytkowników. Niezależnie od tego, czy jesteś osobą fizyczną, czy sprzedawcą, dołącz do promotora 51Shopy, zaproś nowych użytkowników do rejestracji w 51Shopy i dokonaj udanego zakupu, on/ona zostanie Twoim wyłącznym użytkownikiem, a każde jego/jej międzynarodowe zużycie logistyczne przyniesie Ci zwrot gotówki, a kwota zwrotu może wynieść nawet milion juanów, bez górnego limitu.",
    setup643:"Jak obliczany jest mój bonus?",
    setup644:"Gdy zostaniesz członkiem, Twoje konto od razu będzie miało stawkę rabatu. Im więcej użytkowników międzynarodowych usług logistycznych zaprosisz do rejestracji, tym więcej bonusów otrzymasz i tym wyższa będzie stawka rabatu. Gdy bonus osiągnie określoną kwotę, możesz ubiegać się o wypłatę gotówki lub wykorzystać ją do pokrycia wszelkich opłat za usługi platformy 51Shopy. Stawka rabatu wynosi",
    setup645:"Jak promować za darmo?",
    setup646:"Skopiuj swój link promocyjny lub link promocyjny i wyślij go znajomym, klikając Udostępnij na stronie produktu. Kiedy odwiedzą stronę i się zarejestrują, staną się Twoim unikalnym użytkownikiem.",
    setup647:'Czas rejestracji',
    setup648:'Koszty transportu',
    setup649:'Status aktywacji',
    setup650:'Rekord bonusowy',
    setup651:'Czas aplikacji',
    setup652:'Całkowita nagroda',
    setup653:'Zaproś użytkowników',
    setup654:'Przejdź do portfela',
    setup655: "Karta kredytowa",
    setup656: "Zaproś znajomych do skorzystania z prowizji",
    setup657:"Członek stowarzyszony",
    setup658: "Zamówienie zakupu",
    setup659:"Platforma agenta 51Shopy zapewnia pomoc w zakupie produktów online i offline w Chinach. Wystarczy podać link do produktu i złożyć zamówienie, a nasz zespół zapewni obsługę pierwszej klasy od początku do końca",
    setup660: "Wysyłka do magazynu",
    setup661:"U nas możesz kupować produkty od różnych sprzedawców i zlecać ich wysyłkę do magazynu 51Shopy w Chinach",
    setup662: "Kontrola jakości",
    setup663:"Gdy Twoje przedmioty dotrą do magazynu 51Shopy, przeprowadzimy dokładną kontrolę jakości, obejmującą wszystko, od wad po rozmiar i kolor. Możesz być pewien, że 51Shopy oferuje niezawodną gwarancję obsługi posprzedażowej.",
    setup664:"Dostawa globalna",
    setup665:"W magazynie 51Shopy możesz swobodnie wybierać i łączyć produkty, a także korzystać z niezawodnej usługi logistycznej świadczonej przez 51Shopy, aby je zapakować i dostarczyć do domu.",
    setup666: "Kompleksowa obsługa, bezstresowy proces",
    setup667:"Po zarejestrowaniu się zaproszeni użytkownicy otrzymają USD:",
    setup668: "Darmowa wysyłka",
    setup669: "Bez kosztów przesyłki",
    setup670: "Wysyłka międzynarodowa nie jest wliczona w cenę",
    setup671:"Firma logistyczna",
    setup672:"Wybierz firmę logistyczną",
    setup673:"Ostatni numer nadawcy",
    setup674: "Ostatnie cztery cyfry",
    setup675: "Numer nadawcy",
    setup676:"Proszę wpisać",
    setup677: "Oczekiwanie na zapisanie",
    setup678: "Czy w cenę wliczona jest opłata za wysyłkę międzynarodową?",
    setup679: "Tak",
    setup680: "Nie",
    setup681: "Kliknij przycisk „Dodaj do ekranu głównego”",
}
//波兰